import {
  MDBBadge,
  MDBDropdown,
  MDBDropdownItem,
  MDBDropdownMenu, MDBDropdownToggle,
  MDBIcon,
  MDBLightbox,
  MDBLightboxItem,
  MDBNavbar,
  MDBNavbarBrand,
  MDBNavbarItem,
  MDBNavbarLink,
  MDBNavbarNav, MDBNavbarToggler,
  MDBRipple
} from 'mdb-react-ui-kit';
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { NavbarContext } from "../components/context/NavProvider";

import ClearDataButton from "./../ClearDataButton";
import { CartContext } from './context/CartProvider';
import { CategoryContext } from './context/CategoryContext';
import { DomainContext } from './context/DomainProvider';
import { GeographyContext } from './context/GeographyProvider';
import { UserProfileContext } from './context/UserProfileProvider';
import './customNavbar.css';
import LoginModal from './login/LoginModal';
import { fetchIPAddress, fetchMainPageData, getDomainsAndCategories } from './utils/Common';
const Navbar = () => {
 const { tokenLoaded } = useContext(UserProfileContext);
  const {  avatar, setBasicOpen, basicOpen, business, isPricing, isDark, setIsDark, containerRef,pageData,setPageData, setIsPricing,setBusiness} = useContext(NavbarContext);
  const {selectDomains,setSelectDomains,setGroupedDomainsByDomain,setDomainImages,domainId,setDomainId,setFirmId} = useContext(DomainContext);
  const {setGroupedCategoriesByDomain,setCategoryImages,selectCategories,setSelectCategories} = useContext(CategoryContext);

  const {ipAddress,setIPAddress,location,setCountry} = useContext(GeographyContext);
 
  const { cartCount} = useContext(CartContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {    
    fetchMainPageData(pageData,setPageData, setIsPricing,setBusiness);
  }, [setIsPricing, setBusiness, pageData, setPageData]); 

  useEffect(() => {
    const fetchData = async () => {
      if (!ipAddress || ipAddress === 'undefined') {
        await fetchIPAddress(setIPAddress);
      }
      if (selectDomains?.length === 0) {
        getDomainsAndCategories(domainId, location, ipAddress, tokenLoaded, setBusiness, setCountry, setSelectCategories, setSelectDomains, setGroupedCategoriesByDomain, setCategoryImages, setGroupedDomainsByDomain, setDomainImages,setDomainId,setFirmId);
      }
    };
    fetchData();
  }, [ ipAddress]);

  const toggleDropdown = useCallback(() => {
    setDropdownOpen(prevState => !prevState);
   
  }, []);
  const handleClick = () => {
    setIsDark(!isDark);
  }
  const toggleSidenav = () => {
    setBasicOpen(!basicOpen);
  };
  const handleLinkClick = (path) => {
    setDropdownOpen(false); // Close the dropdown directly
    setTimeout(() => {
      navigate(path);
    }, 100);
  };
  const pricingCategories = selectCategories.filter(category => category.isPricing);


  return (
    <MDBNavbar expand='lg' className='rounded' ref={containerRef}>
      {!basicOpen && <MDBNavbarBrand >
        <Link to='/home' className='nav-link'>
          <MDBRipple rippleTag='a' className='mb-3 ms-2 me-5'>
            <img src={localStorage.getItem('LOGO')} alt="Logo" style={{ height: '70px', marginRight: "15px" }} />      Home     
          </MDBRipple>
        </Link>   
      </MDBNavbarBrand>}
      <MDBNavbarToggler
        type='button'
        aria-controls='navbar'
        aria-expanded='false'
        aria-label='Toggle navigation'
        onClick={toggleSidenav} className="custom-toggler mb-3"
      >
        <MDBIcon color='danger' icon="bars" size="2x" fas />
      </MDBNavbarToggler>
     
      <MDBNavbarNav right fullWidth={false} className="d-flex flex-row mb-2 mb-lg-0 justify-content-center align-items-center justify-content-center">
        {selectCategories?.length > 0 &&  <MDBNavbarItem>         
          <MDBDropdown isOpen={dropdownOpen} toggle={toggleDropdown} >
            <MDBNavbarLink active aria-current='page' href={(isPricing || window.location.host.includes("expenses")|| window.location.host.includes("x-trk")) ? '/shop/pricing' : '/products'} className='nav-link text-primary fw-bold '>
              <MDBDropdownToggle tag={Link} className='nav-link text-primary fw-bold me-2' to={isPricing ? '/shop/pricing' : '/products'} onClick={toggleDropdown}>Shop</MDBDropdownToggle>
            </MDBNavbarLink>
            <MDBDropdownMenu responsive={true} >
              {selectCategories?.map((category, index) => (
                <MDBDropdownItem key={index} link  className="sidenav-link text-success text-lowercase justify-content-center text-left mt-0"  onClick={() => handleLinkClick(`/shop/${category.text}`)}>
                  {category.text}
                </MDBDropdownItem>
              ))}
            </MDBDropdownMenu>
          </MDBDropdown>         
        </MDBNavbarItem> }
        <MDBNavbarItem>
          <Link to='/contact' className=' me-3'> Contact
            {/* <MDBRipple rippleTag='a'>
              <img src='https://opengrit.com/images/contactUsIcon' alt="contact" style={{ height: '40.5px' }} />
            </MDBRipple> */}
          </Link>
        </MDBNavbarItem>
        {(business === 'B2C' || isPricing) && cartCount > 0 &&

          <Link to='/cart' className='me-4 '>
            <img src='https://opengrit.com/images/shoppingCartFunctionalityIcon' alt="Cart" style={{ height: '50px' }} className="rounded" />
            <MDBBadge color='success' notification pill>
              {cartCount}
            </MDBBadge>
          </Link>
        }
        {tokenLoaded ?
          <MDBRipple rippleTag='a' className='me-3'>
             {avatar && 
             
             <MDBLightbox>
             <MDBLightboxItem
               style={{ width: 35, height: 35 }}
               zoomlevel={0.25}
               src={avatar || localStorage.getItem('AVATAR') || 'https://opengrit.com/images/avatar'}
               fullscreenSrc={avatar || localStorage.getItem('AVATAR') || <MDBIcon size='2x' fas icon="sign-out-alt" style={{ color: '#ff4500' }} />}
               className="rounded mx-2"
               alt=""
             />
           </MDBLightbox>
             
           }
            <ClearDataButton />
          </MDBRipple>
          : <LoginModal setBasicOpen={setBasicOpen} />
        }

      </MDBNavbarNav>


    </MDBNavbar>


  );
};

export default Navbar;
